(async () => {

  if (!customElements.get('toggle-more')) {

    class ToggleMore extends HTMLElement {

      constructor () {
        super();

        // Default options
        this.options = {
          height: 32,
          desktopHeight: 0,
          mobileHeight: 0,
        }

        // Get options from element data and combine or overwrite this.options
        if (this?.dataset?.options) {
          const dataOptions = JSON.parse(this.dataset.options);
          this.options = {
            ...this.options,
            ...dataOptions
          };
        }
        // Elements
        this.triggerElement = this.querySelector('[data-toggle-more-trigger]');
        this.targetElement = this.querySelector('[data-toggle-more-target]');
        this.contentElement = this.querySelector('[data-toggle-more-content]');
        // Init
        this.init();
        setTimeout(() => {
          this.init();
        }, 1000);

        // Events
        window.addEventListener('resize', () => {
          if(this.classList.contains('toggle-more--is-open')) {
            this.removeHeight();
          } else {
            this.setHeight();
          }
        });

        if (this.triggerElement) {
          this.triggerElement.addEventListener('click', ()=>{
            this.handleTrigger();
          });
        }

      }

      /**
       * init
       */
      init () {
        if(this.contentElement &&this.contentElement.offsetHeight >= this.options.height) {
          this.classList.add('toggle-more--on');
          this.setHeight();
        } else {
          this.classList.remove('toggle-more--on');
          this.classList.remove('toggle-more--is-open');
          this.removeHeight();
        }
      }

      /**
       * handleTrigger
       */
      handleTrigger() {
        this.classList.toggle('toggle-more--is-open');
        if(this.classList.contains('toggle-more--is-open')) {
          this.removeHeight();
        } else {
          this.setHeight();
        }
      }

      /**
       * setHeight
       */
      setHeight() {
        if (!this.contentElement) {
          return;
        }
        const contentHeight = this.contentElement.offsetHeight;
        let desktopHeight = this.options.desktopHeight;
        let mobileHeight = this.options.mobileHeight;

        if (window.innerWidth >= 768) {
          if (desktopHeight > 0) {
            if (contentHeight <= this.options.height) {
              this.targetElement.style.height = `${contentHeight}px`;
            } else {
              this.targetElement.style.height = `${desktopHeight}px`;
            }
          } else {
            if (contentHeight <= this.options.height) {
              this.targetElement.style.height = `${contentHeight}px`;
            } else {
              this.targetElement.style.height = `${this.options.height}px`;
            }
          }
        }

        if (window.innerWidth < 768) {
          if (mobileHeight > 0) {
            if (contentHeight <= this.options.height) {
              this.targetElement.style.height = `${contentHeight}px`;
            } else {
              this.targetElement.style.height = `${mobileHeight}px`;
            }
          } else {
            if (contentHeight <= this.options.height) {
              this.targetElement.style.height = `${contentHeight}px`;
            } else {
              this.targetElement.style.height = `${this.options.height}px`;
            }
          }
        }
      }

      /**
       * removeHeight
       */
      removeHeight() {
        if (this.contentElement) {
          const contentHeight = this.contentElement.offsetHeight;
          this.targetElement.style.height = `${contentHeight}px`;
        }

      }
    }
    window.ToggleMore = ToggleMore;
    customElements.define('toggle-more', ToggleMore);
  }
})();
